import type React from "react";
import type { Theme } from "./theme";

export function Eyebrow({ theme, children }: { theme: Theme; children: React.ReactNode }) {
  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        fontSize: 12,
        fontWeight: 500,
        letterSpacing: 0.5,
        textTransform: "uppercase",
        color: theme.accentFg,
        padding: "5px 10px",
        background: theme.accentSoft,
        border: `1px solid ${theme.accentBorder}`,
        borderRadius: 999,
      }}
    >
      <span style={{ width: 5, height: 5, borderRadius: 99, background: theme.accent }} />
      {children}
    </div>
  );
}

export function SectionHeader({
  theme,
  kicker,
  title,
  children,
}: {
  theme: Theme;
  kicker?: string;
  title: string;
  children?: React.ReactNode;
}) {
  return (
    <div
      style={{
        maxWidth: 1200,
        margin: "0 auto",
        padding: "0 clamp(20px, 5vw, 40px)",
        marginBottom: 48,
      }}
    >
      {kicker && (
        <div
          style={{
            fontSize: 12,
            fontWeight: 500,
            letterSpacing: 0.6,
            textTransform: "uppercase",
            color: theme.accentFg,
            marginBottom: 14,
          }}
        >
          {kicker}
        </div>
      )}
      <h2
        style={{
          fontSize: "clamp(32px, 3.6vw, 48px)",
          lineHeight: 1.05,
          letterSpacing: "-1.2px",
          fontWeight: 600,
          color: theme.fg,
          margin: 0,
          maxWidth: 820,
          textWrap: "balance",
        }}
      >
        {title}
      </h2>
      {children && (
        <div
          style={{
            marginTop: 18,
            fontSize: 17,
            color: theme.fgMute,
            maxWidth: 640,
            lineHeight: 1.55,
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
}
